class StatisticsService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  getTotal(params) {
    return this.apiService.get('/Statistik/Total', params);
  }
}

module.exports = StatisticsService;